import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import styled from 'styled-components'
import { StyledAccommodationRoomTileDetails } from './AccommodationRoomTileDetails'
import { AccommodationRoomTileImageContainer } from './AccommodationRoomTileImage'
import { PropsWithChildren } from 'react'
import React from 'react'

const AccommodationRoomTileGrid = styled.div`
  display: grid;
  grid-template:
    "image" ${rem(223)}
    "details" auto / 1fr;

  ${mediaQueryUp.tablet} {
    grid-template:
      "image" ${rem(320)}
      "details" auto / 1fr;
  }

  ${mediaQueryUp.desktop} {
    grid-template: "image details" auto / ${rem(400)} 1fr;
  }

  > ${AccommodationRoomTileImageContainer} {
    grid-area: image;
  }
  > ${StyledAccommodationRoomTileDetails} {
    grid-area: details;
  }
`

function AccommodationRoomTile(props: PropsWithChildren) {
  return <AccommodationRoomTileGrid {...props} />
}

export default AccommodationRoomTile
